import React from "react";
import { IconPercentage } from "@tabler/icons-react";

import "./styles.scss";

import { Card, Text } from "@fragments";
import Parser from "@helpers/parser.js";
import { WALLET_PROVIDERS } from "@helpers/wallets";

export default function Taxes({
    provider,
    wallet,
    loading,
}) {
    const activeProvider = provider || wallet?.provider || WALLET_PROVIDERS.ASAAS;
    const isStripe = activeProvider === WALLET_PROVIDERS.STRIPE;
    const currency = wallet?.currency || (isStripe ? 'USD' : 'BRL');

    if (loading) {
        return (
            <Card
                flat
                className="withdrawals-taxes-card"
                title="Taxas da conta"
                subtitle="Custos aplicados nas vendas desta carteira."
                icon={<IconPercentage />}
            >
                <div className="taxes-card taxes-card--loading">
                    <div className="left-section">
                        <IconPercentage className="taxes-icon" />
                    </div>
                    <div className="right-section">
                        <Text.label loading contrast={8}>Taxa por venda</Text.label>
                        <Text.span loading contrast={6}>Valor fixo e percentual</Text.span>
                    </div>
                </div>
            </Card>
        );
    }

    if (!wallet?.taxes && !isStripe) return null;

    const taxes = wallet?.taxes;

    return (
        <Card
            flat
            className="withdrawals-taxes-card"
            title="Taxas da conta"
            subtitle={isStripe
                ? "Custos da carteira internacional vinculada ao Stripe."
                : "Custos da carteira nacional vinculada ao Asaas."}
            icon={<IconPercentage />}
        >
            {taxes ? (
                <div className="taxes-card">
                    <div className="left-section">
                        <IconPercentage className="taxes-icon" />
                    </div>

                    <div className="right-section">
                        <div className="info-row">
                            <Text.span contrast={7}>
                                Taxa por venda:
                            </Text.span>
                            <Text.label contrast={9}>
                                {taxes.percentile}% + {Parser.price.format(taxes.fixed, currency)}
                            </Text.label>
                        </div>

                        {!isStripe && (
                            <div className="info-row">
                                <Text.span contrast={7}>
                                    Taxa de parcelamento:
                                </Text.span>
                                <Text.label contrast={9}>
                                    {taxes.anticipation}%
                                </Text.label>
                                <Text.span contrast={7}>
                                    ao mês por parcela
                                </Text.span>
                            </div>
                        )}
                    </div>
                </div>
            ) : (
                <div className="taxes-card taxes-card--empty">
                    <div className="left-section">
                        <IconPercentage className="taxes-icon" />
                    </div>
                    <div className="right-section">
                        <Text.label contrast={8}>Taxas internacionais</Text.label>
                        <Text.span contrast={6}>
                            As taxas aparecem aqui quando forem sincronizadas pela carteira internacional.
                        </Text.span>
                    </div>
                </div>
            )}
        </Card>
    );
}
